import { render, staticRenderFns } from "./Dfts.vue?vue&type=template&id=787b54d0&"
import script from "./Dfts.vue?vue&type=script&lang=js&"
export * from "./Dfts.vue?vue&type=script&lang=js&"
import style0 from "./Dfts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports